import { styled } from '@mui/material/styles';

const StyledAgentName = styled('h1')`
  margin: 0;
  text-transform: capitalize;
  line-height: 56px;
`;

export default StyledAgentName;
